import React, { useState } from 'react';
import { faqs } from '../../data/faqs';
import { site } from '../../data/site';
import { Container } from '../ui/Container';
import { SectionTitle } from '../ui/SectionTitle';
import { FaqItem } from './FaqItem';
export function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);
  return <section id="faq" aria-labelledby="faq-title" className="bg-white py-20 lg:py-28" data-id="element-85" data-mp="jkm28yxo468k">
      <Container className="grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-86" data-mp="emu07c3b73qn">
        <div className="lg:col-span-4" data-id="element-87" data-mp="ajxom5c6s7w7">
          <div className="lg:sticky lg:top-28" data-id="element-88" data-mp="aiw131dzhsxl">
            <SectionTitle id="faq-title" data-id="element-89" data-mp="5l48s69fg4sv">Questions families ask</SectionTitle>
            <p className="text-pretty mt-6 leading-relaxed text-muted" data-id="element-90" data-mp="5n78ji0dtcas">
              Don’t see yours? Call{' '}
              <a href={site.phoneHref} className="font-semibold text-ink underline decoration-brand decoration-2 underline-offset-4" data-id="element-91" data-mp="1zzdhsb9ptj0g">
                {site.phoneDisplay}
              </a>{' '}
              or email{' '}
              <a href={site.emailHref} className="font-semibold text-ink underline decoration-brand decoration-2 underline-offset-4" data-id="element-92" data-mp="1nggalw9gozbz">
                {site.email}
              </a>
              .
            </p>
          </div>
        </div>
        <div className="border-b border-line lg:col-span-8" data-id="element-93" data-mp="1dkmrtv55g9lr">
          {faqs.map(faq => <FaqItem key={faq.id} faq={faq} open={openId === faq.id} onToggle={() => setOpenId(cur => cur === faq.id ? null : faq.id)} data-id="element-94" data-mp="1iiespenrv623" />)}
        </div>
      </Container>
    </section>;
}